import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { closeAllCiSnackbar, openCiSnackbar } from '@iurban-malaga/cicerone-ui';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckRouteByEmail {
  private _http = inject(HttpClient);
  private _router = inject(Router);
  private _translateService = inject(TranslateService);
  
  private _apiUrlBase = environment.apiUrlBase;
  
  public checkRouteByEmail(email: string): void {
    closeAllCiSnackbar();
    
    this._http.post(`${this._apiUrlBase}/api/fitur/check-route-by-email`, { email })
      .subscribe({
        next: (response: any) => {
          console.log('Response from checkRouteByEmail:', response);
          
          const token = response.token;
          this._router.navigate(['/home/route', token]);
          
          // TODO: INIT WEBSOCKET TO INITIATE SENDING THE TOKEN
        },
        error: (error) => {
          console.error('Error in checkRouteByEmail:', error);
          
          this._openErrorSendRouteSnackbar();
        }
      })
  }
  
  private _openErrorSendRouteSnackbar() {
    openCiSnackbar({
      content: this._translateService.instant(
        'Error al cargar la ruta por email. Por favor, revise que el email es correcto y coincide con el utilizado al enviar la ruta previamente',
      ),
      status: 'error',
      'icon-name': 'alert',
      'horizontal-position': 'end',
      'vertical-position': 'bottom',
    });
  }
}
